(ns common.schema.entities.named-view.schema
  (:require
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    ;; Both filters, per the internal-user-selector rule in CLAUDE.md: the
    ;; option filter constrains the local dropdown, the os-filter-terms-fn
    ;; constrains the OpenSearch-backed search behind it. Having only one leaves
    ;; the other route offering deactivated accounts, and this field's default
    ;; editor is :editor.type/select, so it does render a picker.
    (su/single-ref-field :named-view/account
                         "Account"
                         [:entity.type/account]
                         {:authorization      su/access-user-user
                          :option-filter-fn   option-filters/active-users
                          :os-filter-terms-fn (fn [_args]
                                                {"extras.active-user" true})})
    (su/text-simple-field :named-view/name
                          "Name"
                          {:authorization su/access-user-user})
    (su/text-edn-field :named-view/settings
                       "Settings"
                       {:authorization su/access-user-user})
    (su/keyword-field :named-view/view
                      "View"
                      nil
                      {:authorization su/access-user-user})
    (su/integer-field :named-view/schema-version
                      "Schema version"
                      {:authorization su/access-user-user}))))
